import moment from 'moment'
import { Status } from '../../../Status'
import { Typography } from '../../../Typography'
import { timelineDateFormat } from '../../../Timelines/constants'
import { StatusWithDateCellProps } from './types'
import './styles.scss'

export const StatusWithDateCell = ({
  date,
  dateLabel,
  statusName,
  statusClassName
}: StatusWithDateCellProps) => (
  <div className="status-with-date-cell column gap-4">
    <Status.Default className={statusClassName}>{statusName}</Status.Default>
    {date && (
      <Typography.Caption>
        {`${dateLabel}: ${moment(date).format(timelineDateFormat)}`}
      </Typography.Caption>
    )}
  </div>
)
